import { render, staticRenderFns } from "./ExpandingInsertButton.vue?vue&type=template&id=07db2f95&scoped=true&"
import script from "./ExpandingInsertButton.vue?vue&type=script&lang=js&"
export * from "./ExpandingInsertButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingInsertButton.vue?vue&type=style&index=0&id=07db2f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db2f95",
  null
  
)

export default component.exports